import Footer from '~/components/Footer'
import Navigation from '~/components/Navigation'

export default function Privacy() {
  return (
    <>
      <Navigation />
      <div className="w-full max-w-3xl mx-auto px-4 flex flex-col gap-4">
        <h1 className="pt-3">Privacy Policy</h1>
        <p>
          We are committed to protect the privacy of our registered users and Website visitors. We
          therefore commit to, at any time, follow the terms of this Privacy Policy. This Privacy
          Policy describes your privacy rights regarding the kind of information we collect from
          you, how we may use it and how we protect it.{' '}
        </p>
        <p className="whitespace-pre-wrap pb-3">
          This Privacy Policy shall apply to the use of the services provided at Heja, a service
          owned and provided by Heja Sports AB (“Heja”, “we”, “our”, “us”), Swedish reg. no.
          559147-3177, a company incorporated under the laws of Sweden and whose registered office
          is located at Folkungagatan 122, 116 30 Stockholm, SWEDEN
        </p>
        <p>
          If you represent a legal entity you ensure and are responsible for making your physical
          representatives, employees etc. aware of the contents stated herein.
        </p>
        <h4>What is personal data?</h4>
        <p>
          For the purposes of this Privacy Policy, your ”Personal Data” means any information about
          you from which you are directly or indirectly personally identifiable, including, but not
          limited to, your name, address and email address (and where applicable, your login name
          and password) and other information from which you can be identified and which you may
          disclose to Heja or otherwise via the service at any time.
        </p>
        <h4>
          When and what information do we process about you, for what purposes and how is it lawful
          for us to do it?
        </h4>
        <p>
          When you register for Heja’s services, we collect personal data from you such as your
          phone number, first and last name and date of birth.
        </p>
        <p>
          <strong>Our use of your personal data</strong>
        </p>
        <p>
          To enable the use of your account, authenticate logins and using our service we process
          data, such as:
        </p>
        <ul>
          <li>Contact details (first and last name, age, phone number, email and address)</li>

          <li>Account credentials (Facebook-authentication)</li>

          <li>Information about your children (when you provide this information to us).</li>

          <li>Cookie-data</li>

          <li>
            Information about your mobile device (device identifier, operating system, manufacture,
            IP-address etc.)
          </li>
        </ul>
        <p>
          We process your data with customer relationship as legal ground and to fulfil our
          contractual obligation when you register.
        </p>
        <p>
          To assist you with good service and support and maintain further feature improvements we
          process data, such as:
        </p>
        <ul>
          <li>Contact details (first and last name, phone number and email)</li>

          <li>Analytics data about your usage of the service</li>

          <li>
            Information about your mobile device (device identifier, operating system, manufacture,
            IP-address etc.)
          </li>
        </ul>
        <p>We process your data with customer relationship as legal ground.</p>
        <h4>Sharing of data with third parties</h4>
        <p>
          Personal data collected from you may be shared with third party providers of Heja that
          process personal data on behalf of Heja; such as server hosting providers, data storage
          providers, customer support and analytics systems. These third parties may be located in
          countries other than your country and your personal data may therefore be subject to
          privacy laws that are different from the ones in your country.
        </p>
        <p>
          When Personal data are processed outside of the EU/ESS, Heja shall ensure that the
          transfer of your personal data is carried out in accordance with applicable privacy laws
          and, in particular, that appropriate contractual, technical and organisational measures
          are in place such as the Standard Contractual Clauses approved by the EU Commission.
        </p>
        <p>
          We may use <strong>Intercom</strong> in connection with our Services to store and track
          usage statistics, support conversations and contact information such as name and email in
          connection with those support live chat conversations. Intercom is used for customer
          support purposes. In particular, we provide a limited amount of your information (such as
          sign-up date and some personal information like your email address) to Intercom Inc.
          (“Intercom”) and utilize Intercom to collect data for analytics purposes when you visit
          our website or use our product. As a data processor acting on our behalf, Intercom
          analyzes your use of our website and/or product and tracks our relationship by way of
          cookies and similar technologies so that we can improve our service to you. For more
          information on Intercom’s use of cookies, please visit{' '}
          <a href="https://www.intercom.com/terms-and-policies#cookie-policy">
            https://www.intercom.com/terms-and-policies#cookie-policy
          </a>
          . We may also use Intercom as a medium for communications, either through email, or
          through messages within our product(s). As part of our service agreements, Intercom
          collects publicly available contact and social information related to you, such as your
          email address, gender, company, job title, photos, website URLs, social network handles
          and physical addresses, to enhance your user experience. Processing takes place in the
          United States. Intercom is self-certified under the US-EU Privacy Shield and we have
          entered into a Data Processing Addendum with them. For more information on the privacy
          practices of Intercom, please visit their privacy policy. Intercom’s services are governed
          by Intercom’s terms of use which can be found at{' '}
          <a href="https://www.intercom.com/terms-and-policies#terms">
            https://www.intercom.com/terms-and-policies#terms
          </a>
          .
        </p>
        <p>
          If you choose to use Heja for payments we may collect credit card or additional payment
          information from you. However, it’s important to note that we do not process any of your
          payments on our servers, but rather use a third party payment service known as ‘Stripe’.
          Therefore, any information regarding your payment processing and security must be verified
          in Stripe’s own <a href="https://stripe.com/us/ssa">Terms of Service Agreement</a> and{' '}
          <a href="https://stripe.com/ie/privacy">Privacy Policy</a>. The payment processor,
          ‘Stripe’, may provide us with unique authentication tokens to make future payments
          requests more convenient.
        </p>
        <p>
          <strong>Authorities</strong>
        </p>
        <p>
          We can disclose personal data to regulatory authorities or legal advisors in connection
          with any alleged criminal offence or suspected breach of the Terms of Service or where
          Heja is under a duty to disclose or share your Personal Data in order to comply with any
          legal obligation.
        </p>
        <p>
          <strong>Transfer of data to a third country</strong>
        </p>
        <p>
          Your data will only be processed within EU/EEA (European Economic Area) or to a third
          country only when we can comply with all applicable laws in respect of such transfer,
          including making sure that your personal data is kept secure.
        </p>
        <p>
          When we transfer data to providers in the US we base such transfer on Privacy Shield. More
          information about Privacy Shield which is an agreement on protection of personal data
          between EU and US can be found here:{' '}
          <a href="https://www.privacyshield.gov/welcome">https://www.privacyshield.gov/welcome</a>.
        </p>
        <h4>For how long do we keep your data</h4>
        <p>
          We will only keep your personal data for as long you stay as a registered user. In the
          event of longer inactivity, we will erase your data on regular basis.
        </p>
        <p>
          However some data may be necessary to keep for a longer time to fulfil contracts and/or
          legal requirements and some data may be anonymized to prevent history for teams and
          organizations.
        </p>
        <h4>Your rights</h4>
        <p>
          You have the right to request access to and rectification or erasure of your personal data
          processed by Heja.{' '}
        </p>
        <p>If you wish to exercise this right, please contact us at privacy@heja.io.</p>
        <p>
          You always have the opportunity to add or edit your own Personal Data and you may also
          erase and delete the information when you disable your user account.
        </p>
        <h4>Security</h4>
        <p>
          We will take all steps reasonably necessary to ensure that your Personal Data is treated
          securely and in accordance with this Privacy Policy. All Personal Data provided to us is
          stored on secure servers. Unfortunately, the transmission of any information via the
          internet and mobile networks is not entirely secure. Although we will do our best to
          protect your Personal Data, we cannot guarantee the security of the Personal Data
          transmitted to the Website. Any transmission is at your own risk. However, once we have
          received your Personal Data, we will use strict procedures and security features to try to
          prevent unauthorised access.
        </p>
        <h4>Cookies</h4>
        <p>
          We uses cookies in order to improve our services and create statistics of your and other
          user use of the Website. Cookies are files that are saved by your web browser on your
          device (e.g. computer or phone). These files consist of text and are named after the
          websites you have visited. You can choose to not receive cookies in your web browser.{' '}
        </p>
        <p>
          Disabling cookies in your browser is easy and only takes a couple of minutes. Below you’ll
          find links to guides for the most common browsers:
        </p>
        <p>
          Chrome:{' '}
          <a href="https://support.google.com/chrome/answer/95647">
            https://support.google.com/chrome/answer/95647
          </a>
        </p>
        <p>
          Safari:{' '}
          <a href="https://support.apple.com/kb/Ph41411">https://support.apple.com/kb/Ph41411</a>
        </p>
        <p>
          Firefox:{' '}
          <a href="https://support.mozilla.org/en-US/kb/block-websites-storing-site-preferences">
            https://support.mozilla.org/en-US/kb/block-websites-storing-site-preferences
          </a>
        </p>
        <p>
          Explorer:{' '}
          <a href="http://windows.microsoft.com/en-us/internet-explorer/delete-manage-cookies#ie=ie-1">
            http://windows.microsoft.com/en-us/internet-explorer/delete-manage-cookies#ie=ie-1
          </a>
        </p>
        <p>
          We use <strong>Google Analytics</strong> to measure the pages you visit, time spent on
          pages, when you last visited them and where you came from. If you want to opt out from
          Google Analytics, see:{' '}
          <a href="https://tools.google.com/dlpage/gaoptout">
            https://tools.google.com/dlpage/gaoptout
          </a>
        </p>
        <p>
          When you visit our websites, advertising cookies will be placed on your computer so that
          we can understand where you have been on our website. Our partners,{' '}
          <strong>AdRoll</strong> and <strong>DoubleClick</strong>, then enable us to present you
          with retargeting advertising on other sites based on your previous interaction with us.
          The techniques our advertising partners employ do not collect personal information such as
          your name, email address, postal address or telephone number.
        </p>
        <p>
          You can visit this{' '}
          <a href="http://optout.networkadvertising.org/#!/">
            http://optout.networkadvertising.org/#!/
          </a>{' '}
          to opt out of <strong>AdRoll</strong>, <strong>DoubleClick</strong> and their respective
          partners’ targeted advertising.
        </p>
        <h4>Links to third parties websites or services</h4>
        <p>
          Heja can, from time to time, contain links to and from the websites of third parties. If
          you follow a link to any of these websites, please note that these websites have their own
          privacy policies and that we are not, under any circumstances, responsible or liable for
          these policies. Please check these policies before you submit any Personal Data to these
          websites.
        </p>
        <h4>Changes of this Privacy Policy</h4>
        <p>
          We reserves the right to, at any time and of any reason, amend this Privacy Policy. We
          will not diminish your rights under this Privacy Policy or under applicable data
          protection laws. All amended terms shall be effective thirty (30) days after they are
          initially posted. However, if we make changes that we deems necessary to fulfil legal
          requirements, such new terms shall apply immediately after having been published.
        </p>
      </div>
      <Footer />
    </>
  )
}
